import { ProcedureHistoricalProps } from './props';
import { useProcedureHistorical } from './hook';
import { Table } from '../../../../components/general/table';
import { useState } from 'react';

export const ProcedureHistorical = (
    historical: ProcedureHistoricalProps,
    showHistorical?: ProcedureHistoricalProps
) => {
    const { columns, rows } = useProcedureHistorical(historical);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });

    const handlePaginationChange = (newPagination: {
        page: number;
        pageSize: number;
    }) => {
        setPaginationModel(newPagination);
    };

    const paginatedRows = rows.slice(
        paginationModel.page * paginationModel.pageSize,
        (paginationModel.page + 1) * paginationModel.pageSize
    );

    if (!showHistorical) {
        return null;
    }

    return (
        <Table
            columns={columns}
            rows={paginatedRows}
            rowCount={rows.length}
            paginationModel={paginationModel}
            onPaginationModelChange={handlePaginationChange}
            pageSizeOptions={[10, 20, 50]}
            disableRowSelectionOnClick
        />
    );
};
